import React from 'react'
import { FormHelperText, Typography } from '@mui/material'
import { FormControl } from '@mui/material'
import { colors } from 'src/theme'
import tw from 'twin.macro'

interface Props {
  name?: string
  css?: any
  label?: string
  placeholder?: string
  value?: string | number
  error?: boolean
  helperText?: string | false
  disabled?: boolean
  options: Array<BasicButtonGroupOption>
  onChange(value: string | number): void
  onBlur?: (e: React.FocusEvent<any>) => void
}

export interface BasicButtonGroupOption {
  label: string
  value: string | number
}

export const BasicButtonGroup = ({
  css,
  label,
  value,
  error,
  helperText,
  options,
  disabled,
  onChange,
}: Props) => {
  const handleChange = (value: string | number) => {
    onChange(value)
  }

  return (
    <div css={css}>
      {label && (
        <Typography css={tw`mb-1`} variant="h6" color={colors.GRAY_COOL_GRAY}>
          {label}
        </Typography>
      )}
      <FormControl fullWidth error={error}>
        <div css={tw`rounded-lg py-1 px-0.5 bg-[#F6F6F6] flex flex-row`}>
          {options.map((option, index) => {
            const selected = value === option.value && !disabled
            const nextSelected =
              options[index + 1] && value === options[index + 1].value && !disabled

            return (
              <div css={tw`flex flex-1 items-center`} key={option.value}>
                <div
                  css={[
                    tw`h-8 mx-0.5 flex flex-1 justify-center items-center rounded-[6px]`,
                    selected ? tw`bg-white` : tw`bg-[#F6F6F6]`,
                    disabled ? tw`bg-[#F6F6F6] cursor-default` : tw`cursor-pointer hover:bg-white`,
                  ]}
                  onClick={!disabled ? () => handleChange(option.value) : undefined}
                >
                  <Typography
                    color={selected ? colors.BASICS_BLACK : colors.SHADES_GREY_600}
                    variant={selected ? 'h6' : 'subtitle1'}
                  >
                    {option.label}
                  </Typography>
                </div>
                {index < options.length - 1 && !selected && !nextSelected && (
                  <div css={tw`w-[1px] h-4 bg-[#DAD9E0]`} />
                )}
              </div>
            )
          })}
        </div>
        {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </FormControl>
    </div>
  )
}
